<div *transloco="let t; read: 'shared.betaFeature.dialog'">
  <div mat-dialog-title class="dialog-title">
    <p>
      {{ t('title.main') }}
    </p>
    <button mat-icon-button mat-dialog-close disableRipple (click)="onClose()">
      <mat-icon> close </mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <div class="flex flex-col justify-center gap-4 p-2 whitespace-pre-line">
      <p class="text-justify">
        {{ t('content.' + (modalData.contentType || 'specific')) }}
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <a [href]="emailTemplate" mat-flat-button>
      {{ t('action.primary') }}
    </a>
  </mat-dialog-actions>
</div>
